/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RateSummary } from './RateSummary';
import {
    RateSummaryFromJSON,
    RateSummaryFromJSONTyped,
    RateSummaryToJSON,
    RateSummaryToJSONTyped,
} from './RateSummary';
import type { RateType } from './RateType';
import {
    RateTypeFromJSON,
    RateTypeFromJSONTyped,
    RateTypeToJSON,
    RateTypeToJSONTyped,
} from './RateType';
import type { CurrencyAmount } from './CurrencyAmount';
import {
    CurrencyAmountFromJSON,
    CurrencyAmountFromJSONTyped,
    CurrencyAmountToJSON,
    CurrencyAmountToJSONTyped,
} from './CurrencyAmount';
import type { RawRateSummary } from './RawRateSummary';
import {
    RawRateSummaryFromJSON,
    RawRateSummaryFromJSONTyped,
    RawRateSummaryToJSON,
    RawRateSummaryToJSONTyped,
} from './RawRateSummary';

/**
 * A set of rates that fall into predefined categories. One refundable, one nonrefundable, and the price differential (refundable - nonrefundable)
 * @export
 * @interface RateGroup
 */
export interface RateGroup {
    /**
     * 
     * @type {RateSummary}
     * @memberof RateGroup
     */
    refundableRate?: RateSummary;
    /**
     * 
     * @type {RateSummary}
     * @memberof RateGroup
     */
    nonrefundableRate?: RateSummary;
    /**
     * 
     * @type {RawRateSummary}
     * @memberof RateGroup
     */
    rawRefundableRate?: RawRateSummary;
    /**
     * 
     * @type {RawRateSummary}
     * @memberof RateGroup
     */
    rawNonrefundableRate?: RawRateSummary;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof RateGroup
     */
    differential?: CurrencyAmount;
    /**
     * 
     * @type {RateType}
     * @memberof RateGroup
     */
    rateType: RateType;
    /**
     * 
     * @type {boolean}
     * @memberof RateGroup
     */
    recommended?: boolean;
}



/**
 * Check if a given object implements the RateGroup interface.
 */
export function instanceOfRateGroup(value: object): value is RateGroup {
    if (!('rateType' in value) || value['rateType'] === undefined) return false;
    return true;
}

export function RateGroupFromJSON(json: any): RateGroup {
    return RateGroupFromJSONTyped(json, false);
}

export function RateGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): RateGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'refundableRate': json['refundable_rate'] == null ? undefined : RateSummaryFromJSON(json['refundable_rate']),
        'nonrefundableRate': json['nonrefundable_rate'] == null ? undefined : RateSummaryFromJSON(json['nonrefundable_rate']),
        'rawRefundableRate': json['raw_refundable_rate'] == null ? undefined : RawRateSummaryFromJSON(json['raw_refundable_rate']),
        'rawNonrefundableRate': json['raw_nonrefundable_rate'] == null ? undefined : RawRateSummaryFromJSON(json['raw_nonrefundable_rate']),
        'differential': json['differential'] == null ? undefined : CurrencyAmountFromJSON(json['differential']),
        'rateType': RateTypeFromJSON(json['rate_type']),
        'recommended': json['recommended'] == null ? undefined : json['recommended'],
    };
}

export function RateGroupToJSON(json: any): RateGroup {
    return RateGroupToJSONTyped(json, false);
}

export function RateGroupToJSONTyped(value?: RateGroup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'refundable_rate': RateSummaryToJSON(value['refundableRate']),
        'nonrefundable_rate': RateSummaryToJSON(value['nonrefundableRate']),
        'raw_refundable_rate': RawRateSummaryToJSON(value['rawRefundableRate']),
        'raw_nonrefundable_rate': RawRateSummaryToJSON(value['rawNonrefundableRate']),
        'differential': CurrencyAmountToJSON(value['differential']),
        'rate_type': RateTypeToJSON(value['rateType']),
        'recommended': value['recommended'],
    };
}

